module.exports = __webpack_public_path__ + "img/89.afbe33b3.png";